// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"dddd1729","329":"2cbe8d33","606":"2906fc1b"}[chunkId] + ".chunk.css";
};